<section class="container-lg">
  @for (item of pressReleaseSection.items; track item.id) {
    <article class="row flex-row press-release-item">
      <div class="col-12 col-lg-6 image-wrapper">
        @if (item.image) {
          <div class="tags">
            <wb-tag variant="tertiary" theme="light">
              <wb-icon [name]="cardTagConfig[item.cardType].icon"></wb-icon>
              {{ cardTagConfig[item.cardType].label | translate }}
            </wb-tag>
            @if (item.isArchived) {
              <!-- class lives on a wrapper: Angular hydration re-applies static classes on SSR'd wb-* hosts and wipes Stencil's `hydrated` -->
              <span class="archived-tag">
                <wb-tag variant="tertiary" theme="light">{{ 'ARCHIVED_CONTENT' | translate }}</wb-tag>
              </span>
            }
          </div>
          <mb-image [media]="item.image"></mb-image>
        }
      </div>

      <div class="container-sm col-12 col-lg-6 content-wrapper">
        <div class="row">
          <div class="col-12 content">
            <div class="section-location-date copy-s">
              <span>{{ item.location }}</span>
              <span>, {{ item.displayDate | localizedDate: 'longDate' }}</span>
            </div>
            <h3>{{ item.title }}</h3>
            @if (item.fuelLabel) {
              <div [innerHTML]="item.fuelLabel" class="copy-s fuel-label"></div>
            }
            <div class="copy-l content-text" [innerHTML]="item.content"></div>
            <button routerLink="{{ item.link }}" class="btn btn-secondary btn-read-more">
              {{ 'READ_MORE' | translate }}
            </button>
            <div class="section-footer">
              <mb-meta-items [metaItems]="item.metaItems" class="meta-items"></mb-meta-items>
              <mb-action-container [buttonItems]="defaultActions" [resource]="item.resource"></mb-action-container>
            </div>
          </div>
        </div>
      </div>
    </article>
  }
</section>
